import { combineReducers } from "redux";
import auth from "./auth";
import { main } from "./main";
import cart from "./cart";

export default combineReducers({
  auth,
  main,
  cart,
});
